import { InputAdornment, TextField } from "@mui/material";
import React from "react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { useSelector } from "react-redux";

const NumberInput = ({
  name,
  placeholder,
  onChangeValue,
  onBlurValue,
  value,
  startIcon = false,
  helperText,
  disabled = false,
}) => {
  const themeColor = useSelector((state) => state.themeColorReducer.lightColor);

  return (
    <TextField
      type="number"
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      fullWidth
      color="black"
      helperText={helperText}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {startIcon && <PersonOutlineIcon />}
          </InputAdornment>
        ),
      }}
      onChange={onChangeValue}
      onBlur={onBlurValue}
      value={value}
      sx={{
        "& .MuiInputBase-root": {
          height: "35px",
        },
        "& .MuiInputBase-input": {
          padding: "6px 12px",
        },
        "& .Mui-disabled": {
          background: themeColor ? "rgb(45, 45, 50)" : "rgb(233,236,239)",
          color: themeColor ? "#aaa" : "#666",
          WebkitTextFillColor: themeColor ? "#aaa" : "#666", // ensures text color applies in Chrome
        },
      }}
    />
  );
};

export default NumberInput;
